let ptBR = {
    name: "Português do Brasil",
    tag: 'pt-br',
    values: {

    }
}

export default ptBR